(function (angular) {
    angular.module('bizPartEngage').controller('cleanbase.unsubscribe', unsubscribe);

    unsubscribe.$inject = ['$rootScope'];

    function unsubscribe($rootScope) {
        var vm = this;

        
    }
})(window.angular);